export const fields = `
  _key,
  _type,
  label,
  linkType,
  linkType == "internal" => {
    'link': internalLink -> {
      _id,
      _type,
      'slug': slug.current
    }
  },
  linkType == "file" => {
    'link': fileLink.asset->url
  },
  linkType == "iframeSlideout" => {
    'iframeUrl': iframeUrl,
    'iframeScript': iframeScript,
    'link': internalLink -> {
      _id,
      _type,
      'slug': slug.current
    }
  },
  linkType == "external" => { 'link': externalLink },
  videoPopoutType,
  videoId,
  hash,
  icon,
  eventName,
  navigationOffset,
  linkNested[] {
    _key,
    _type,
    label,
    linkType,
    linkType == "internal" => {
      'link': internalLink -> {
        _id,
        _type,
        'slug': slug.current
      }
    },
    linkType == "file" => {
      'link': fileLink.asset->url
    },
    linkType == "iframeSlideout" => {
      'iframeUrl': iframeUrl,
      'iframeScript': iframeScript,
      'link': internalLink -> {
        _id,
        _type,
        'slug': slug.current
      }
    },
    linkType == "external" => {
      'link': externalLink
    }
  }
`

export const fragment = (name = 'link') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
